import React from 'react'
import { getSubdomain } from '../../utils/general'
import subdomainStyles from '../../subdomainStyles.json'
import formatters from "../../utils/forms/formatters";
import {pullSubdomainStyleFromCookie} from "../../utils/subdomains/configHandlers";

export default class TelephoneNumber extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      phone: null
    }
  }

  componentDidMount() {
    let subdomainStyles = pullSubdomainStyleFromCookie();
    let phone = subdomainStyles['contact-phone'] || '8773017800';
    this.setState({phone})
  }

  render() {
    return (
      <span className={this.props.className}>
        {formatters.phone.formatter(this.state.phone)}
      </span>
    )
  }
}